import React from "react";

class Services extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section id="services" className="add-padding">
          <div className="container">
            <h1 className="section-title big-text scrollimation fade-up">
              My Services
            </h1>
            <hr />

            <div className="row">
              <div className="col-sm-4 service-item color3 scrollimation scale-in">
                <div className="service-icon">
                  <i className="fa fa-scissors"></i>
                </div>

                <h1>
                  <strong>Cuts</strong>
                </h1>
                <hr />
                <p className="h3">Expert</p>
                <br />
                <p className="h3">Contemporary</p>
                <br />
                <p className="h3">Trending</p>
              </div>

              <div className="col-sm-4 service-item color1 scrollimation scale-in d1">
                <div className="service-icon">
                  <i className="fa fa-paint-brush "></i>
                </div>

                <h1>
                  <strong>Colors</strong>
                </h1>
                <hr />
                <p className="h3">Color Correction</p>
                <br />
                <p className="h3">Highlight</p>
                <br />
                <p className="h3">Babylight</p>
                <br />
                <p className="h3">Platinum</p>
              </div>

              <div className="col-sm-4 service-item color2 scrollimation scale-in d2">
                <div className="service-icon">
                  <i className="fa fa-star"></i>
                </div>

                <h1>
                  <strong>Treatments</strong>
                </h1>
                <hr />
                <p className="h3">Keratin Straightening</p>
                <br />
                <p className="h3">Brazilian Blowout</p>
                <br />
                <p className="h3">Extensions</p>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default Services;
